import { ActionType } from 'typesafe-actions';

import * as merchantsActions from './actions';
import { SET_MERCHANTS_AND_OFFERS_RS, SET_MERCHANTS_AND_OFFERS_RS_LOADED } from './constants';
import { MerchantAndOffersRS } from '../../types/merchant';
import { clone } from 'lodash';

export type MerchantsAction = ActionType<typeof merchantsActions>;

export type MerchantsState = {
  merchantsAndOffersRS: Record<string, MerchantAndOffersRS>;
  merchantsAndOffersRSLoaded: Record<string, boolean>;
};

const defaultState: MerchantsState = {
  merchantsAndOffersRS: {},
  merchantsAndOffersRSLoaded: {},
};

export default (state = defaultState, action: MerchantsAction): MerchantsState => {
  switch (action.type) {
    case SET_MERCHANTS_AND_OFFERS_RS: {
      const updatedMerchantsAndOffers = action.payload.reduce(
        (acc, merchant) => {
          acc[merchant.merchant_id] = merchant;
          return acc;
        },
        {
          ...state.merchantsAndOffersRS,
        }
      );
      return {
        ...state,
        merchantsAndOffersRS: updatedMerchantsAndOffers,
      };
    }
    case SET_MERCHANTS_AND_OFFERS_RS_LOADED: {
      const newData = clone(state.merchantsAndOffersRSLoaded);
      if (action.payload.remove) {
        action.payload.ids.forEach((id) => {
          if (newData[id]) {
            delete newData[id];
          }
        });
      } else {
        action.payload.ids.forEach((id) => {
          newData[id] = !!action.payload.loaded;
        });
      }

      return {
        ...state,
        merchantsAndOffersRSLoaded: newData,
      };
    }
    default:
      return state;
  }
};
